const factsEn = [
    {
      id: 1,
      title: "Virality Isn’t Random — It’s Patterned 📊",
      insight:
        "Across 1,000 of the most popular YouTube videos, similar emotional hooks repeat again and again — regardless of niche.",
      videos: [
        { title: "How I Learned Faster Than 99% of People", published: "2023" },
        { title: "This Study Method Changed My Life", published: "2022" },
        { title: "Why Most Learning Fails", published: "2021" },
      ],
    },
    {
      id: 2,
      title: "Education Can Beat Entertainment 🎓",
      insight:
        "Educational videos regularly outperform pure entertainment when curiosity and emotion are combined.",
      videos: [
        { title: "Study Less, Learn More", published: "2023" },
        { title: "How I Remember Everything", published: "2022" },
        { title: "The Science of Learning", published: "2021" },
      ],
    },
    {
      id: 3,
      title: "Titles Decide the Click — Not Thumbnails Alone 🖱️",
      insight:
        "High-performing videos consistently use curiosity-driven titles, even with simple thumbnails.",
      videos: [
        { title: "Nobody Tells You This About Studying", published: "2023" },
        { title: "This Changed How I Learn Forever", published: "2022" },
        { title: "I Tried Every Study Method", published: "2021" },
      ],
    },
    {
      id: 4,
      title: "Long Videos Win on YouTube ⏱️",
      insight:
        "Videos over 10 minutes dominate the top-performing list due to higher watch time and retention.",
      videos: [
        { title: "The Ultimate Guide to Learning Faster", published: "2023" },
        { title: "Deep Work Explained", published: "2022" },
        { title: "How Mastery Actually Works", published: "2021" },
      ],
    },
    {
      id: 5,
      title: "Evergreen Content Compounds Views 🌱",
      insight:
        "Unlike short-form platforms, YouTube rewards content that stays relevant for years.",
      videos: [
        { title: "How to Learn Anything Fast", published: "2020" },
        {
          title: "This Video Still Gets Views After 3 Years",
          published: "2019",
        },
        { title: "Why Evergreen Content Wins", published: "2021" },
      ],
    },
    {
      id: 6,
      title: "Simple Language Beats Expertise 🧠",
      insight:
        "Top education videos explain complex ideas using plain language, not technical jargon.",
      videos: [
        { title: "Math Explained Simply", published: "2023" },
        { title: "Physics Without Equations", published: "2022" },
        { title: "Learning Made Easy", published: "2021" },
      ],
    },
    {
      id: 7,
      title: "Creators Win by Teaching What They Just Learned 🔁",
      insight:
        "Many viral education creators succeed by teaching topics they recently mastered themselves.",
      videos: [
        { title: "I Learned This in 30 Days", published: "2023" },
        { title: "What I Wish I Knew Earlier", published: "2022" },
        { title: "Beginner Mistakes I Made", published: "2021" },
      ],
    },
    {
      id: 8,
      title: "Consistency Beats Perfection 📅",
      insight:
        "Channels that publish regularly grow faster than those chasing perfect production quality.",
      videos: [
        { title: "I Posted Every Day for 30 Days", published: "2023" },
        { title: "Why I Stopped Overthinking YouTube", published: "2022" },
        { title: "How Consistency Changed My Channel", published: "2021" },
      ],
    },
    {
      id: 9,
      title: "Categories Don’t Define Virality — Emotion Does 🧠",
      insight:
        "Education, finance, and tech videos go viral when they trigger curiosity, fear, or hope.",
      videos: [
        { title: "This Changed How I Think Forever", published: "2023" },
        { title: "A Lesson I Learned Too Late", published: "2022" },
        { title: "Why Nobody Told You This", published: "2021" },
      ],
    },
    {
      id: 10,
      title: "YouTube Is a Long Game (And That’s the Advantage) 🕰️",
      insight:
        "Unlike other platforms, YouTube continues sending views to old videos for years.",
      videos: [
        {
          title: "This Video Still Gets Views After 5 Years",
          published: "2019",
        },
        { title: "How YouTube Rewards Patience", published: "2020" },
        { title: "Why Long-Term Content Wins", published: "2021" },
      ],
    },
  ];

const factsHi = [
    {
      id: 1,
      title: "वाइरलिटी रैंडम नहीं है — यह एक पैटर्न है 📊",
      insight:
        "1,000 सबसे लोकप्रिय YouTube वीडियो में, एक ही तरह के इमोशनल हुक्स बार-बार दोहराए जाते हैं — चाहे टॉपिक कोई भी हो।",
      videos: [
        { title: "मैंने 99% लोगों से तेज़ी से कैसे सीखा", published: "2023" },
        { title: "इस स्टडी मेथड ने मेरी ज़िंदगी बदल दी", published: "2022" },
        { title: "ज़्यादातर लर्निंग क्यों फेल हो जाती है", published: "2021" },
      ],
    },
    {
      id: 2,
      title: "एजुकेशन, एंटरटेनमेंट को हरा सकता है 🎓",
      insight:
        "जब जिज्ञासा और भावना को मिलाया जाता है, तो एजुकेशनल वीडियो अक्सर प्योर एंटरटेनमेंट से बेहतर परफॉर्म करते हैं।",
      videos: [
        { title: "कम पढ़ें, ज़्यादा सीखें", published: "2023" },
        { title: "मुझे सब कुछ कैसे याद रहता है", published: "2022" },
        { title: "सीखने का विज्ञान", published: "2021" },
      ],
    },
    {
      id: 3,
      title: "क्लिक का फैसला टाइटल करते हैं — सिर्फ थंबनेल नहीं 🖱️",
      insight:
        "बेहतरीन परफॉर्म करने वाले वीडियो लगातार जिज्ञासा पैदा करने वाले टाइटल का उपयोग करते हैं, भले ही थंबनेल सिंपल हो।",
      videos: [
        {
          title: "पढ़ाई के बारे में यह आपको कोई नहीं बताता",
          published: "2023",
        },
        {
          title: "इसने मेरे सीखने का तरीका हमेशा के लिए बदल दिया",
          published: "2022",
        },
        { title: "मैंने हर स्टडी मेथड को आज़माया", published: "2021" },
      ],
    },
    {
      id: 4,
      title: "YouTube पर लंबे वीडियो जीतते हैं ⏱️",
      insight:
        "10 मिनट से ज़्यादा के वीडियो हाई वॉच टाइम और रिटेंशन के कारण टॉप-परफॉर्मिंग लिस्ट में हावी रहते हैं।",
      videos: [
        { title: "तेज़ी से सीखने की अल्टीमेट गाइड", published: "2023" },
        { title: "डीप वर्क का महत्व", published: "2022" },
        { title: "मास्टरी वास्तव में कैसे काम करती है", published: "2021" },
      ],
    },
    {
      id: 5,
      title: "एवरग्रीन कंटेंट व्यूज को बढ़ाता रहता है 🌱",
      insight:
        "शॉर्ट-फॉर्म प्लेटफॉर्म्स के विपरीत, YouTube उस कंटेंट को रिवॉर्ड देता है जो सालों तक प्रासंगिक बना रहता है।",
      videos: [
        { title: "कुछ भी तेज़ी से कैसे सीखें", published: "2020" },
        {
          title: "इस वीडियो पर 3 साल बाद भी व्यूज आ रहे हैं",
          published: "2019",
        },
        { title: "एवरग्रीन कंटेंट क्यों जीतता है", published: "2021" },
      ],
    },
    {
      id: 6,
      title: "सरल भाषा विशेषज्ञता से बेहतर है 🧠",
      insight:
        "टॉप एजुकेशन वीडियो कठिन विचारों को तकनीकी शब्दों के बजाय सरल भाषा में समझाते हैं।",
      videos: [
        { title: "गणित को सरलता से समझाया गया", published: "2023" },
        { title: "बिना समीकरण के फिजिक्स", published: "2022" },
        { title: "सीखना हुआ आसान", published: "2021" },
      ],
    },
    {
      id: 7,
      title: "क्रिएटर्स वो सिखाकर जीतते हैं जो उन्होंने अभी सीखा है 🔁",
      insight:
        "कई वायरल क्रिएटर्स उन विषयों को सिखाकर सफल होते हैं जिनमें उन्होंने हाल ही में महारत हासिल की है।",
      videos: [
        { title: "मैंने यह 30 दिनों में सीखा", published: "2023" },
        { title: "काश मुझे यह पहले पता होता", published: "2022" },
        { title: "शुरुआती गलतियाँ जो मैंने कीं", published: "2021" },
      ],
    },
    {
      id: 8,
      title: "निरंतरता परफेक्शन से बेहतर है 📅",
      insight:
        "जो चैनल नियमित रूप से पब्लिश करते हैं, वे उन लोगों की तुलना में तेज़ी से बढ़ते हैं जो केवल परफेक्शन के पीछे भागते हैं।",
      videos: [
        { title: "मैंने 30 दिनों तक रोज़ाना पोस्ट किया", published: "2023" },
        {
          title: "मैंने YouTube के बारे में सोचना क्यों बंद कर दिया",
          published: "2022",
        },
        {
          title: "कंसिस्टेंसी ने मेरे चैनल को कैसे बदल दिया",
          published: "2021",
        },
      ],
    },
    {
      id: 9,
      title: "कैटेगरी नहीं, भावनाएं वायरल करती हैं 🧠",
      insight:
        "एजुकेशन, फाइनेंस और टेक वीडियो तब वायरल होते हैं जब वे जिज्ञासा, डर या आशा पैदा करते हैं।",
      videos: [
        { title: "इसने मेरी सोच हमेशा के लिए बदल दी", published: "2023" },
        { title: "एक सबक जो मैंने बहुत देर से सीखा", published: "2022" },
        { title: "किसी ने आपको यह क्यों नहीं बताया", published: "2021" },
      ],
    },
    {
      id: 10,
      title: "YouTube एक लंबी रेस है (और यही इसका फायदा है) 🕰️",
      insight:
        "दूसरे प्लेटफॉर्म्स के विपरीत, YouTube पुराने वीडियो पर सालों तक व्यूज भेजता रहता है।",
      videos: [
        {
          title: "इस वीडियो पर 5 साल बाद भी व्यूज आ रहे हैं",
          published: "2019",
        },
        { title: "YouTube धैर्य को कैसे रिवॉर्ड देता है", published: "2020" },
        { title: "लॉन्ग-टर्म कंटेंट क्यों जीतता है", published: "2021" },
      ],
    },
  ];

const factsFr = [
  {
    id: 1,
    title: "La viralité n'est pas aléatoire — elle suit des schémas 📊",
    insight:
      "Sur 1 000 des vidéos YouTube les plus populaires, des accroches émotionnelles similaires se répètent encore et encore — quel que soit le domaine.",
    videos: [
      { title: "Comment j'ai appris plus vite que 99 % des gens", published: "2023" },
      { title: "Cette méthode d'étude a changé ma vie", published: "2022" },
      { title: "Pourquoi la plupart des apprentissages échouent", published: "2021" },
    ],
  },
  {
    id: 2,
    title: "L'éducation peut battre le divertissement 🎓",
    insight:
      "Les vidéos éducatives surpassent régulièrement le pur divertissement quand la curiosité et l'émotion sont combinées.",
    videos: [
      { title: "Étudiez moins, apprenez plus", published: "2023" },
      { title: "Comment je me souviens de tout", published: "2022" },
      { title: "La science de l'apprentissage", published: "2021" },
    ],
  },
  {
    id: 3,
    title: "Les titres décident du clic — pas seulement les miniatures 🖱️",
    insight:
      "Les vidéos les plus performantes utilisent systématiquement des titres axés sur la curiosité, même avec des miniatures simples.",
    videos: [
      { title: "Personne ne vous dit ça sur les études", published: "2023" },
      { title: "Cela a changé ma façon d'apprendre pour toujours", published: "2022" },
      { title: "J'ai essayé toutes les méthodes d'étude", published: "2021" },
    ],
  },
  {
    id: 4,
    title: "Les vidéos longues gagnent sur YouTube ⏱️",
    insight:
      "Les vidéos de plus de 10 minutes dominent le classement des meilleures performances grâce à un temps de visionnage et une rétention plus élevés.",
    videos: [
      { title: "Le guide ultime pour apprendre plus vite", published: "2023" },
      { title: "Le travail en profondeur expliqué", published: "2022" },
      { title: "Comment la maîtrise fonctionne vraiment", published: "2021" },
    ],
  },
  {
    id: 5,
    title: "Le contenu intemporel accumule les vues 🌱",
    insight:
      "Contrairement aux plateformes de formats courts, YouTube récompense le contenu qui reste pertinent pendant des années.",
    videos: [
      { title: "Comment apprendre n'importe quoi rapidement", published: "2020" },
      {
        title: "Cette vidéo reçoit encore des vues après 3 ans",
        published: "2019",
      },
      { title: "Pourquoi le contenu intemporel gagne", published: "2021" },
    ],
  },
  {
    id: 6,
    title: "Un langage simple bat l'expertise 🧠",
    insight:
      "Les meilleures vidéos éducatives expliquent des idées complexes dans un langage clair, sans jargon technique.",
    videos: [
      { title: "Les maths expliquées simplement", published: "2023" },
      { title: "La physique sans équations", published: "2022" },
      { title: "L'apprentissage rendu facile", published: "2021" },
    ],
  },
  {
    id: 7,
    title: "Les créateurs gagnent en enseignant ce qu'ils viennent d'apprendre 🔁",
    insight:
      "De nombreux créateurs éducatifs viraux réussissent en enseignant des sujets qu'ils viennent eux-mêmes de maîtriser.",
    videos: [
      { title: "J'ai appris ça en 30 jours", published: "2023" },
      { title: "Ce que j'aurais aimé savoir plus tôt", published: "2022" },
      { title: "Les erreurs de débutant que j'ai faites", published: "2021" },
    ],
  },
  {
    id: 8,
    title: "La régularité bat la perfection 📅",
    insight:
      "Les chaînes qui publient régulièrement grandissent plus vite que celles qui courent après une qualité de production parfaite.",
    videos: [
      { title: "J'ai publié chaque jour pendant 30 jours", published: "2023" },
      { title: "Pourquoi j'ai arrêté de trop réfléchir sur YouTube", published: "2022" },
      { title: "Comment la régularité a changé ma chaîne", published: "2021" },
    ],
  },
  {
    id: 9,
    title: "Les catégories ne définissent pas la viralité — l'émotion si 🧠",
    insight:
      "Les vidéos d'éducation, de finance et de tech deviennent virales lorsqu'elles déclenchent la curiosité, la peur ou l'espoir.",
    videos: [
      { title: "Cela a changé ma façon de penser pour toujours", published: "2023" },
      { title: "Une leçon que j'ai apprise trop tard", published: "2022" },
      { title: "Pourquoi personne ne vous a dit ça", published: "2021" },
    ],
  },
  {
    id: 10,
    title: "YouTube est un jeu de longue haleine (et c'est son avantage) 🕰️",
    insight:
      "Contrairement aux autres plateformes, YouTube continue d'envoyer des vues vers d'anciennes vidéos pendant des années.",
    videos: [
      {
        title: "Cette vidéo reçoit encore des vues après 5 ans",
        published: "2019",
      },
      { title: "Comment YouTube récompense la patience", published: "2020" },
      { title: "Pourquoi le contenu à long terme gagne", published: "2021" },
    ],
  },
];

export const youtubeFacts = {
  en: factsEn,
  hi: factsHi,
  fr: factsFr,
};
